import React, { memo, useState, useEffect } from 'react';
import { Modal, Upload, Button, Skeleton, Input } from 'antd';
import { useSelector } from 'react-redux';
import { API } from '@service';
import alert from '@components/alert';
import { getPdfUploadClientError } from '@utils/pdfUploadValidation';

function UploadAndViewPdf(props) {
  const propFileName = props.value
    ? `${props.value.split('/')[props.value.split('/').length - 1]}.pdf`
    : null;
  const projectId = useSelector((state) => state.common.currentId);
  const { changeLink, handleStatus, uploadAPI = API.uploadPdf, type } = props;
  const [hasUploaded, setHasUploaded] = useState(Boolean(props.value));
  const [showUpload, setShowUpload] = useState(false);
  const [isFetching, toggleIsFetching] = useState(false);

  const [fileName, setFileName] = useState(propFileName);

  const [file, setFile] = useState(null);
  const [reupload, setReupload] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [extValid, setExtValid] = useState(true);
  const [clientPdfError, setClientPdfError] = useState(null);
  const validateFile = (file) => {
    const clientErr = getPdfUploadClientError(file);
    if (clientErr) {
      alert.error(clientErr);
      setClientPdfError(clientErr);
      setExtValid(false);
      return false;
    }
    setClientPdfError(null);
    setExtValid(true);
    const fileReader = new FileReader();
    fileReader.onload = () => {
      setFile(file);
      setFileName(file.name);
    };
    fileReader.readAsBinaryString(file);
    return false;
  };
  const handleOk = async () => {
    setConfirmLoading(true);
    if (!file) {
      alert.error('Please choose a file to upload');
      setConfirmLoading(false);
      return;
    }
    const clientErr = getPdfUploadClientError(file);
    if (clientErr) {
      alert.error(clientErr);
      setConfirmLoading(false);
      return;
    }
    const formData = new FormData();
    formData.append('file', file);
    formData.append('name', fileName);
    const res = await uploadAPI(projectId, formData, type);
    if (res?.id) {
      if (handleStatus) {
        handleStatus(true);
      }
      changeLink(projectId, res.id);
      setConfirmLoading(false);
      setShowUpload(false);
      setHasUploaded(true);
    } else {
      if (handleStatus) {
        handleStatus(false);
      }
    }
  };

  const handleCancel = () => {
    setConfirmLoading(false);
    if (!hasUploaded && !reupload) {
      setFile(null);
      setFileName(null);
      setShowUpload(false);
      setReupload(false);
      setHasUploaded(false);
    } else if (reupload) {
      setHasUploaded(true);
      setShowUpload(false);
    } else {
      setHasUploaded(true);
      setShowUpload(false);
      setFileName(propFileName);
      // initFileName && setFileName(initFileName);
    }
    setExtValid(true);
    setClientPdfError(null);
  };
  const handleReupload = () => {
    setReupload(true);
    setHasUploaded(false);
    setConfirmLoading(false);
  };
  const handleDelete = () => {
    setShowUpload(false);
    changeLink(projectId, '');
    setFile(null);
    setFileName(null);
    // setInitFileName(null);
    setHasUploaded(false);
    setReupload(false);
  };
  const renderFooter = () => {
    if (!hasUploaded || props.uploadOnlyNoEditAndDelete) {
      return (
        <div>
          <Button
            type="primary"
            loading={confirmLoading}
            onClick={handleCancel}
          >
            Cancel
          </Button>
          <Button
            loading={confirmLoading}
            onClick={handleOk}
            disabled={!extValid}
          >
            Upload
          </Button>
        </div>
      );
    }
    return (
      <div style={{ width: '100%', textAlign: 'left' }}>
        <Button onClick={handleDelete}>Delete</Button>
        <Button type="primary" onClick={handleReupload}>
          Reupload
        </Button>
      </div>
    );
  };

  const getPdf = props.shouldgetrReportPDF ? API.getReportPdf : API.getPdf;

  useEffect(() => {
    (async () => {
      if (props.value && showUpload) {
        toggleIsFetching(true);

        const { fileName } = await getPdf(props.value, projectId);

        setFileName(fileName);

        toggleIsFetching(false);
      }
    })();
  }, [showUpload]);
  return (
    <>
      <div
        className="upload-pdf-text"
        onClick={() => {
          setShowUpload(true);
        }}
      >
        {!hasUploaded || props.uploadOnlyNoEditAndDelete
          ? 'Upload PDF'
          : 'Edit PDF'}
      </div>

      <Modal
        className={`upload-modal upload-pdf${
          hasUploaded && !props.uploadOnlyNoEditAndDelete
            ? ' edit-pdf-modal'
            : ''
        }`}
        title={
          !hasUploaded || props.uploadOnlyNoEditAndDelete
            ? 'Upload PDF'
            : 'Edit PDF'
        }
        visible={showUpload}
        // onOk={handleOk}
        onCancel={handleCancel}
        footer={renderFooter()}
      >
        {!hasUploaded || props.uploadOnlyNoEditAndDelete ? (
          <>
            <Upload.Dragger
              beforeUpload={(file) => validateFile(file)}
              maxCount={1}
              showUploadList={false}
              accept=".pdf,application/pdf"
            >
              Drag and drop or <span>choose your files</span>
            </Upload.Dragger>
            {!extValid && clientPdfError ? (
              <div className="active-color">{clientPdfError}</div>
            ) : null}
          </>
        ) : null}

        {isFetching && !fileName ? (
          <div className="file-list wrap-anywhere">
            <Skeleton paragraph={false} active />
          </div>
        ) : fileName ? (
          <>
            <div
              className="edit-pdf-filename-input-wrapper"
              style={{ width: '100%' }}
            >
              <Input
                className="edit-pdf-filename-input"
                value={fileName}
                readOnly
                autoComplete="off"
                style={{ width: '100%' }}
              />
            </div>
            {!extValid && clientPdfError ? (
              <div className="active-color">{clientPdfError}</div>
            ) : null}
          </>
        ) : null}
      </Modal>
    </>
  );
}

export default memo(UploadAndViewPdf);
